<template>
  <div>
    <ais-instant-search
      :search-client="searchClient"
      index-name="pro_TURISMO_2"
      :stalled-search-delay="2000"
    >
      <div class="w-full py-5 bg-gray-100 lg:px-20 xl:px-40">
        <h1
          class="px-3 text-xl font-thin tracking-tight text-gray-500 uppercase"
        >
          {{ $t("Encuentra tu establecimiento") }} - {{ bono }}
        </h1>

        <div class="w-full my-2">
          <div class="px-3">
            <ais-search-box
              :placeholder="`${$t('Buscar Establecimiento')}...`"
            />
          </div>
          <div class="flex items-center w-full mx-auto text-left">
            <div class="w-full px-3 py-4 mx-auto md:flex md:-mx-2">
              <div class="py-2 md:w-1/2 md:px-2">
                <h3 class="text-gray-500">{{ $t("Tipo Bono") }}</h3>
                <ais-menu-select
                  :transform-items="filtrarBono"
                  :limit="150"
                  attribute="BONO.NOMBREBONO"
                >
                  <template slot="defaultOption">
                    {{ $t("Todos") }}
                  </template>
                </ais-menu-select>
              </div>
              <div class="py-2 md:w-1/2 md:px-2">
                <h3 class="text-gray-500">{{ $t("Municipio") }}</h3>
                <ais-menu-select :limit="150" attribute="POBLACION">
                  <template slot="defaultOption">
                    {{ $t("Todos los municipios") }}
                  </template>
                </ais-menu-select>
              </div>
              <div class="py-2 md:w-1/2 md:px-2">
                <h3 class="text-gray-500">{{ $t("Código Postal") }}</h3>
                <ais-menu-select :limit="150" attribute="CP">
                  <template slot="defaultOption">
                    {{ $t("Todos") }}
                  </template>
                </ais-menu-select>
              </div>
              <div class="py-2 md:w-1/2 md:px-2">
                <h3 class="text-gray-500">{{ $t("Sector Actividad") }}</h3>
                <ais-menu-select
                  :transform-items="filtrarSector"
                  :limit="50"
                  attribute="SECTORES.NOMBRE"
                >
                  <template slot="defaultOption">
                    {{ $t("Todos") }}
                  </template>
                </ais-menu-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex w-full">
        <div class="w-full lg:px-20 xl:px-40">
          <ais-current-refinements
            :included-attributes="[
              'BONO.NOMBREBONO',
              'CP',
              'POBLACION',
              'SECTORES.NOMBRE',
            ]"
          >
            <ul
              class="flex flex-wrap text-sm text-white"
              slot-scope="{ items, createURL }"
            >
              <li
                class="px-1 py-1 "
                v-for="item in items"
                :key="item.attribute"
              >
                <ul class="px-2 py-1 bg-blue-800 rounded">
                  <li
                    v-for="refinement in item.refinements"
                    :key="
                      [
                        refinement.attribute,
                        refinement.type,
                        refinement.value,
                        refinement.operator,
                      ].join(':')
                    "
                  >
                    <a
                      :href="createURL(refinement)"
                      @click.prevent="item.refine(refinement)"
                    >
                      {{ refinement.label }} x
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </ais-current-refinements>
        </div>
      </div>
      <div class="flex text-left">
        <!-- <div class="w-full bg-gray-100 md:w-1/3">
        <div class="p-2">
          <h3>Provincia</h3>
          <ais-refinement-list attribute="properties.territory">
          </ais-refinement-list>
        </div>
        <div class="p-2">
          <h3>Localidad</h3>
          <ais-refinement-list attribute="POBLACION">
          </ais-refinement-list>
        </div>
        <div class="p-2">
          <h3>Tipo Establecimiento</h3>
          <ais-refinement-list attribute="SECTORES.NOMBRE">
          </ais-refinement-list>
        </div>

      </div> -->
        <div class="w-full lg:px-20 xl:px-40">
          <div class="p-2">
            <ais-state-results>
              <template slot-scope="{ query, hits }">
                <!-- <pre>{{hits.length}} </pre> -->
                <div>
                  <div class="font-thin" v-if="hits.length < 1">
                    {{ $t("No hay resultados para")
                    }}<span class="font-semibold"> {{ query }}. </span>
                  </div>

                  <h3 class="py-2">{{ $t("Resultados") }}</h3>

                  <ais-infinite-hits>
                    <div
                      class="flex flex-wrap md:-mx-3"
                      slot-scope="{ items, isLastPage, refineNext }"
                    >
                      <!-- <mapa-establecimientos :items="items">

                    </mapa-establecimientos> -->

                      <div
                        class="w-full max-w-screen-sm md:w-1/2 md:px-3 lg:w-1/3 xl:w-1/3"
                        v-for="item in items"
                        :key="item.objectID"
                      >
                        <button
                          class="w-full mb-3 text-left border border-gray-200 rounded-b shadow-xs hover:shadow-lg"
                        >
                          <div
                            class="px-2 py-2 font-bold tracking-tighter text-gray-800 uppercase truncate bg-gray-100 border-b border-gray-300 rounded-t hover:bg-gray-100"
                          >
                            {{ item.NOMBRE }}
                          </div>
                          <div
                            class="relative w-full bg-gray-100 bg-center bg-no-repeat bg-cover md:bg-cover"
                          >
                            <img
                              :src="getImagen(item)"
                              :alt="`imagen ${item.NOMBRE}`"
                            />
                            <div
                              v-if="item.CAMPANYA.AGOTADO == 'S'"
                              class="absolute bottom-0 flex flex-col justify-center w-full h-16 font-bold text-white opacity-75 bg-bono-bizkaia"
                            >
                              <div class="flex px-2 ">
                                <svg
                                  class="pt-1"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 13 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12.8325 9.84791L7.50012 1.00454C7.29003 0.656158 6.90681 0.439728 6.49998 0.439728C6.09314 0.439728 5.70992 0.656158 5.49981 1.00457L0.167447 9.84791C-0.0496682 10.208 -0.056092 10.6591 0.150664 11.0253C0.357471 11.3914 0.747116 11.6189 1.16759 11.6189H11.8324C12.2528 11.6189 12.6425 11.3914 12.8493 11.0252C13.0561 10.6591 13.0496 10.2079 12.8325 9.84791ZM12.1123 10.6091C12.0554 10.7098 11.9481 10.7725 11.8324 10.7725H1.16759C1.05183 10.7725 0.944554 10.7099 0.887653 10.6091C0.830727 10.5083 0.832505 10.3841 0.892249 10.285L6.22467 1.44162C6.28251 1.34572 6.38801 1.28613 6.5 1.28613C6.61198 1.28613 6.71747 1.34572 6.77531 1.44162L12.1077 10.285C12.1675 10.3841 12.1693 10.5083 12.1123 10.6091Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M6.50393 3.922C6.18198 3.922 5.93071 4.09476 5.93071 4.40102C5.93071 5.33544 6.04063 6.6782 6.04063 7.61266C6.04065 7.85608 6.25269 7.95815 6.50395 7.95815C6.6924 7.95815 6.95939 7.85608 6.95939 7.61266C6.95939 6.67823 7.0693 5.33547 7.0693 4.40102C7.0693 4.09478 6.81019 3.922 6.50393 3.922Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M6.51182 8.49997C6.16633 8.49997 5.90717 8.7748 5.90717 9.10462C5.90717 9.42658 6.1663 9.70928 6.51182 9.70928C6.83377 9.70928 7.10863 9.42658 7.10863 9.10462C7.10863 8.7748 6.83375 8.49997 6.51182 8.49997Z"
                                    fill="white"
                                  />
                                </svg>
                                <span class="pl-2 leading-4 uppercase">
                                  {{ $t("AGOTADO BONO") }}
                                </span>
                              </div>
                            </div>
                          </div>
                          <!-- :style="`background-image: url('${getImagen(item)}')`" -->

                          <div
                            class="flex flex-col justify-between h-64 py-1 overflow-hidden"
                          >
                            <div class="px-2 text-sm text-gray-600">
                              <!-- <div> {{item.DESCRIPCION}} </div> -->
                              <div class="text-base">
                                {{ item.DESCRIPCION }}
                              </div>
                              <div class="flex -ml-1 text-right">
                                <div
                                  class="mb-2"
                                  v-for="sector in item.SECTORES"
                                  :key="sector.IDSECTORACTIVIDAD"
                                >
                                  <span
                                    class="px-2 mr-1 text-xs italic bg-gray-100 rounded-full shadow-xs"
                                    v-if="sector.NOMBRE != 'Ninguno'"
                                  >
                                    {{ $t(sector.NOMBRE) }}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div class="p-2 mt-2 ">
                              <div class="text-xs font-black">
                                {{ item.DIRECCION }}
                              </div>
                              <div class="text-xs">
                                {{ item.TELEFONO }}
                              </div>
                              <div
                                class="pr-3 mt-2 text-xs font-semibold text-right"
                              >
                                {{ item.CP }} {{ item.POBLACION }},
                                {{ item.PROVINCIA }}
                              </div>
                            </div>
                          </div>
                        </button>
                      </div>
                      <div
                        v-if="!isLastPage"
                        class="w-full px-5 mx-2 bg-gray-100 rounded hover:bg-gray-300"
                      >
                        <button @click="refineNext" class="w-full py-4">
                          {{ $t("Ver más") }}
                        </button>
                      </div>
                      <div
                        v-else
                        class="w-full px-5 mx-2 bg-gray-100 rounded hover:bg-gray-300"
                      >
                        <button @click="scrollTop" class="w-full py-4">
                          {{ $t("Arriba") }}
                        </button>
                      </div>
                    </div>
                  </ais-infinite-hits>
                </div>
              </template>
            </ais-state-results>
          </div>
          <div class="my-2">
            <ais-configure
              :hits-per-page.camel="18"
              :filters="`PROVINCIA:${bono} AND ${filtro}`"
            />
          </div>
        </div>
      </div>
    </ais-instant-search>
  </div>
</template>

<script>
import algoliasearch from "algoliasearch/lite";
const a = [];
export default {
  data() {
    return {
      imgUrl:
        "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/establecimientos%2Fleioa%2Fleia_base.jpg?alt=media",
      searchClient: algoliasearch(
        "8H42AU98XI",
        "7fd26c6a7e5f153b2818a999603c1b3b"
      ),
      filtro: "BONO.IDCAMPANYA:7",
    };
  },
  computed: {
    bono() {
      return this.$store.state.bonoName;
    },
  },
  methods: {
    filtrarSector(items) {
      return items;
    },
    filtrarBono(items) {
      const bonos = [
        "BIZKAIA BONO DENDA",
        "BONO ACTIV. INTERÉS TURÍSTICO/INTERES TURISTIKOKO JARDUERAK",
        "BONO ALOJAMIENTO / OSTATU-BONOA",
        "BONO DENDA",
        "BONO HOSTELERÍA / OSTALARITZA-BONOA",
        "BONO OSTALARITZA / HOSTELERIA",
        "BONO RESTAURACIÓN / JATETXE-ARLOKO BONOA",
      ];

      return items.filter(
        (item) =>
          item.value ==
            "BONO ACTIV. INTERÉS TURÍSTICO/INTERES TURISTIKOKO JARDUERAK" ||
          item.value == "BONO ALOJAMIENTO / OSTATU-BONOA" ||
          item.value == "BONO HOSTELERÍA / OSTALARITZA-BONOA" ||
          item.value == "BONO RESTAURACIÓN / JATETXE-ARLOKO BONOA"
      );
    },
    filtrar(helper) {
      if (helper.state.query) {
        helper.search();
      }
    },
    ver(valor) {
      this.$store.commit("bonoActual", valor);
      this.$router.push(`/${this.$i18n.locale}/detalle-taquilla`);
      // cl*("datos", valor);
    },
    getImagen(valor) {
      let imagen = valor.URLIMAGEN == "1" ? this.imgUrl : valor.URLIMAGEN;
      return imagen;
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
/* .fondo {
  background-color: #2a4365;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='199' viewBox='0 0 100 199'%3E%3Cg fill='%23b2b2b2' fill-opacity='0.4'%3E%3Cpath d='M0 199V0h1v1.99L100 199h-1.12L1 4.22V199H0zM100 2h-.12l-1-2H100v2z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
} */
.ais-SearchBox-input {
  width: 100%;

  padding: 5px;
  border-radius: 5px;
  border: 1px #eeeeee solid;
}
.ais-MenuSelect-select {
  width: 100%;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  padding: 2px;
  border-radius: 5px;
}
.ais-SearchBox-submit {
  top: 12px;
  right: 10px;
  position: absolute;
}
.ais-SearchBox-resetIcon {
  height: 10px;
}
.ais-SearchBox-reset {
  height: 10px;
  width: 10px;
  position: absolute;
  top: 10px;
  right: 30px;
}
.ais-MenuSelect-option {
  background: white;
  -webkit-appearance: none;
  appearance: none;
  -moz-appearance: none;
}
</style>
